import { mapBoard } from './daily-checkin.mappers';
import type { ApiFetchDailyCheckinPort } from '~/handlers/ports/api-fetch-daily-checkin.port';
import type { DailyCheckinBoard } from '~/types/daily-checkin';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoAuthHeaders } from '~/utils/apostatudo/get-apostatudo-auth-headers';

// GET /daily-check-in/board — trilha do período corrente + estado do jogador
// numa resposta só (o épico exige isso pra o front não encadear requests).
//
// Identidade segue a convenção das rotas públicas do core: `user_id` na query
// e o Bearer só pra barrar anônimo. É dívida técnica conhecida e registrada no
// épico (um token válido pode ler o board de outro user_id); a correção é a
// introspecção de token, que tem épico próprio.
//
// Limite do core: 120 req/min. O cache do handler (5 min) é o que garante que
// abrir e fechar o modal não encoste nesse teto.
export class ApostatudoApiFetchDailyCheckinAdapter
  implements ApiFetchDailyCheckinPort
{
  async handle({ userId }: { userId: number }): Promise<DailyCheckinBoard> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(
      `${getApostatudoApiUrl()}/daily-check-in/board?user_id=${userId}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...getApostatudoAuthHeaders(),
        },
        signal: controller.signal,
      },
    ).finally(() => clearTimeout(timeoutId));

    if (!response.ok) {
      throw new Error(`DailyCheckin board failed: ${response.status}`);
    }

    // Resposta plana, sem envelope `data` — o board é o corpo inteiro.
    return mapBoard(await response.json());
  }
}
